/** @format */

import axios from "axios";
// import alertify from "alertifyjs";
import { getAlert } from "../../util/alert";
import Constantes from "../../util/Constantes";

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;

const PATH_LOCATION = Constantes().ApiConfig.PATH_LoginAttorney;
const ENDPOINT = `${SERVER}${PATH_LOCATION}`;
const headers = Constantes().ApiConfig.headers;
const API = {
  updateAttorney: async (objCodigo, alertMessage) => {
    try {
      const URL = `${SERVER}${
        Constantes().ApiConfig.PATH_UpdatePasswordAttorney
      }`;
      let result = await axios.post(URL, objCodigo, {
        headers: headers,
      });
      if (result == undefined) {
        getAlert(Constantes().noRegistros, Constantes().login, alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().noRegistros, "", alertMessage);
      }
      return await result.data;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },

  ValidateToken: async (objCodigo, alertMessage) => {
    try {
      const URL = `${SERVER}${Constantes().ApiConfig.PATH_ValidateToken}`;
      let result = await axios.post(URL, objCodigo, {
        headers: headers,
      });
      if (result == undefined) {
        getAlert(Constantes().noRegistros, Constantes().login, alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().noRegistros, "", alertMessage);
      }
      return await result.data;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },

  GetEmail: async (dni, alertMessage) => {
    try {
      const URL = `${SERVER}${
        Constantes().ApiConfig.PATH_GetEmailAttorneyForDni
      }`;
      let result = await axios.get(`${URL}${dni}`, {
        headers: headers,
      });
      if (result.data.Status == "NOK") {
        getAlert(Constantes().noDNI, "", alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().noRegistros, "", alertMessage);
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },

  sendMailCredencial: async (objCodigo, alertMessage) => {
    // const URL = `${SERVER}${Constantes().ApiConfig.PATH_SendMailCredencial}`;
    // await axios.post(URL, objCodigo, {
    //   headers: headers,
    // });
    try {
      const URL = `${SERVER}${Constantes().ApiConfig.PATH_SendMailCredencial}`;
      let result = await axios.post(URL, objCodigo, {
        headers: headers,
      });
      if (result.data == "NOK") {
        getAlert(
          Constantes().noMail,
          process.env.REACT_APP_SERVER_URL_UPNHOSTBASE,
          alertMessage
        );
      }
      return await "OK";
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },

  loginAttorney: async (objUser, alertMessage) => {
    try {
      const URL = `${SERVER}${Constantes().ApiConfig.PATH_LoginAttorney}`;
      let result = await axios.post(URL, objUser, {
        headers: headers,
      });
      if (result == undefined) {
        getAlert(Constantes().noRegistros, Constantes().login, alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.detail.length == 0) {
        getAlert(Constantes().noRegistros, "", alertMessage);
      }
      return await result.data;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
  },
};

export default API;
